<template>
	<div class="text-justify">
		<div class="row">
			<!-- School History Table -->
			<div class="col-lg-12">
				<student-profile-tab-school-school-history-table />
			</div>
			<!-- Form -->
			<div class="col-lg-12 mt-8">
				<form
					ref="form"
					data-url=""
					class="mb-0"
					@submit.prevent="submit"
				>
					<div class="row">
						<!-- Plan to move to another school in 3 years radio button -->
						<div class="col-md-12 ml-3">
							<div class="form-group row">
								<label for="radio_plan_to_move" class="col-lg-3">
									Plan to move to another school in 3 years:
								</label>
								<div class="col-lg-9">
									<app-input
										id="radio_plan_to_move"
										type="radio"
										:list="yes_and_no_list"
										v-model="
											inputs.plan_to_move_to_another_school_in_3_years
										"
									/>
								</div>
							</div>
						</div>

						<!-- Form if plan to move to another school in 3 years is yes -->
						<div
							class="col-md-12 ml-3"
							v-if="
								inputs.plan_to_move_to_another_school_in_3_years ==
								'yes'
							"
						>
							<div class="row">
								<!-- Next School Name -->
								<div class="col-md-4">
									<div class="form-group">
										<label for="input_next_school_name">Next School Name</label>
										<input
											id="input_next_school_name"
											type="text"
											v-model="inputs.next_school_name"
											placeholder="Next School Name"
											name="first_name"
											class="form-control"
											required
										/>
									</div>
								</div>
								<!-- School Level -->
								<div class="col-md-4">
									<div class="form-group">
										<label for="input_school_level"> School Level </label>
										<app-input
											id="input_school_level"
											type="search-select"
											:list="school_level_list"
											v-model="inputs.school_level"
											placeholder="School Level"
										/>
									</div>
								</div>
								<!-- Have Chinese Lesson at School -->
								<div class="col-md-4">
									<div class="form-group">
										<label for="radio_chinese_lesson"
											>Have Chinese Lesson at
											School</label
										>
										<app-input
											id="radio_chinese_lesson"
											type="radio"
											:list="yes_and_no_list"
											v-model="
												inputs.have_chinese_lesson_at_school
											"
										/>
									</div>
								</div>
							</div>
						</div>

						<!-- Interested to study abroad radio button -->
						<div class="col-md-12 ml-3">
							<div class="form-group row">
								<label for="radio_interested_study_abroad" class="col-lg-3">
									Interested to study abroad:
								</label>
								<div class="col-lg-9">
									<app-input
										id="radio_interested_study_abroad"
										type="radio"
										:list="yes_and_no_list"
										v-model="
											inputs.interested_to_study_abroad
										"
									/>
								</div>
							</div>
						</div>

						<!-- Form if interested to study abroad is yes -->
						<div
							class="col-md-12 ml-3"
							v-if="inputs.interested_to_study_abroad == 'yes'"
						>
							<!-- Country or City of Destination -->
							<div class="form-group row align-items-center">
								<label class="col-md-2 mb-md-0" for="input_country_or_city_of_destination">
									Country or City of Destination
								</label>
								<app-input
									id="input_country_or_city_of_destination"
									class="col-md-8"
									type="text"
									v-model="
										inputs.country_or_city_of_destination
									"
									:placeholder="
										'Type name of country or city of destination'
											| translate
									"
								/>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-5 ml-4 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								@click.prevent="submit"
							>
								{{ $t("submit") }}
							</button>
							<button
								type="submit"
								class="btn btn-secondary"
								@click.prevent="clear"
							>
								{{ $t("clear") }}
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin";

export default {
	mixins: [FormMixin],
	data() {
		return {
			inputs: {
				plan_to_move_to_another_school_in_3_years: "no",
				next_school_name: "",
				school_level: "",
				have_chinese_lesson_at_school: "no",
				interested_to_study_abroad: "no",
				country_or_city_of_destination: "",
			},
			school_name_list: [
				{ id: "school_name_1", value: "School Name 1" },
				{ id: "school_name_2", value: "School Name 2" },
				{ id: "school_name_3", value: "School Name 3" },
			],
			school_level_list: [
				{ id: "school_level_1", value: "School Level 1" },
				{ id: "school_level_2", value: "School Level 2" },
				{ id: "school_level_3", value: "School Level 3" },
			],
			yes_and_no_list: [
				{ id: "no", value: "No" },
				{ id: "yes", value: "Yes" },
			],
		};
	},
	methods: {
		submit() {
			// Handle form submission here
		},
		clear() {
			// Clear form fields here
			this.inputs = {
				plan_to_move_to_another_school_in_3_years: "no",
				next_school_name: "",
				school_level: "",
				have_chinese_lesson_at_school: "no",
				interested_to_study_abroad: "no",
				country_or_city_of_destination: "",
			};
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
